import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-picker-wrapper d-flex flex-column gap-2" }
const _hoisted_2 = { class: "text-uppercase" }
const _hoisted_3 = { class: "date-picker-wrapper__form" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "label mb-1",
  for: "startdate"
}, "Start date", -1)
const _hoisted_5 = { class: "date-picker-wrapper__form__startdate d-flex gap-2 justify-content-start align-items-center mb-2" }
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  class: "label mb-1",
  for: "duedate"
}, "Due date", -1)
const _hoisted_8 = { class: "date-picker-wrapper__form__duedate d-flex gap-2 justify-content-start align-items-center" }
const _hoisted_9 = ["checked"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_date_picker, {
      modelValue: _ctx.defaultDate,
      "onUpdate:modelValue": _ctx.handleDefaultDateChange,
      range: Array.isArray(_ctx.defaultDate),
      inline: true,
      "month-change-on-scroll": false,
      is24: false,
      "month-name-format": 'long',
      format: "MM/d/Y",
      "auto-apply": true,
      "week-start": 0
    }, {
      "calendar-header": _withCtx(({ index }) => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getDay(index)), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue", "range"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hasRange) = $event)),
          disabled: "",
          class: "form-check-input",
          type: "checkbox",
          id: "startdate"
        }, null, 512), [
          [_vModelCheckbox, _ctx.hasRange]
        ]),
        _createElementVNode("input", {
          type: "text",
          disabled: "",
          value: _ctx.formatted.startDate,
          class: _normalizeClass(["form-control form-control-sm", { isFocused: _ctx.hasRange }])
        }, null, 10, _hoisted_6)
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("input", {
          disabled: true,
          checked: _ctx.dueDateCheckBox,
          class: "form-check-input",
          type: "checkbox",
          id: "duedate"
        }, null, 8, _hoisted_9),
        _createElementVNode("input", {
          value: _ctx.formatted.dueDate,
          type: "text",
          ref: "dueDateStart",
          class: _normalizeClass(["form-control form-control-sm", { isFocused: _ctx.dueDateCheckBox }])
        }, null, 10, _hoisted_10),
        _createElementVNode("input", {
          value: _ctx.formatted.dueTime,
          type: "text",
          class: _normalizeClass(["form-control form-control-sm", { isFocused: _ctx.dueDateCheckBox }])
        }, null, 10, _hoisted_11)
      ]),
      _createElementVNode("button", {
        class: "date-picker-wrapper__btn btn-primary-1 w-100 mt-3 rounded-1",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
      }, " Save ")
    ])
  ]))
}